import React, { useEffect, useMemo, useState } from "react";
import { ArticlesFilteredsTypes } from "../../../models/news-articles/articles-filtered-model";
import Newsarticle from "./news-article";
import LoadRegulatoryFocusAds from "../../../components/advertisement/load-regulatory-focus-ads";

type PropsType = {
  articles: ArticlesFilteredsTypes[];
};

const NewsArticleBottom = (props: PropsType) => {
  const ArticlesFilteredsData = props.articles;

  const cachedUseDfpSlot = useMemo(() => <LoadRegulatoryFocusAds />, []);

  const [isArticlesListed, setIsArticlesListed] = useState(false);

  useEffect(() => {
    if (ArticlesFilteredsData[0]?.articlesList.length > 0 && !isArticlesListed){
      setIsArticlesListed(true);
    }
  }, [ArticlesFilteredsData])

  return (
    <div className="post-list post-list-data row">
      {ArticlesFilteredsData[0]?.articlesList?.map((item, index) => {
        return (
          <React.Fragment key={index}>
            {index === 8 && (
              <div className="col-md-12" key={"ads1" + index}>
                <div className="row img-width">
                  <div className="col-md-12 text-center CMSBanner Banner topbanner gadsbanner" id="div-gpt-ad-1649702008484-0" style={{ minWidth: "970px", minHeight: "90px", display: "none" }}></div>
                  <div className="col-md-12 text-center CMSBanner Banner topmobile gadsbanner" id="div-gpt-ad-1649702035816-0" style={{ minWidth: "300px", minHeight: "50px", display: "none" }}></div>
                </div>
              </div>
            )}
            {index >= 4 ? (
              <div className="col-md-6" key={index}>
                <Newsarticle article={item} />
              </div>
            ) : null}
          </React.Fragment>
        );
      })}
      {isArticlesListed && cachedUseDfpSlot}
    </div>
  );
};

export default NewsArticleBottom;
